<template>
  <div class="year-range-picker">
    <el-select v-model="startYear" placeholder="起始年份" @change="handleStartYearChange">
      <el-option
        v-for="year in yearOptions"
        :key="year"
        :label="year + '年'"
        :value="year">
      </el-option>
    </el-select>
    <span class="separator">至</span>
    <el-select v-model="endYear" placeholder="结束年份" @change="handleEndYearChange">
      <el-option
        v-for="year in yearOptions"
        :key="year"
        :label="year + '年'"
        :value="year">
      </el-option>
    </el-select>
  </div>
</template>

<script>
export default {
  name: 'YearRangePicker',
  props: {
    value: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      startYear: null,
      endYear: null,
      yearOptions: []
    }
  },
  created() {
    this.initYearOptions()
    this.initDefaultYears()
  },
  methods: {
    initYearOptions() {
      const currentYear = new Date().getFullYear()
      // 生成从大前年到今年的年份选项
      this.yearOptions = Array.from({ length: 4 }, (_, index) => currentYear - 3 + index)
    },
    initDefaultYears() {
      const currentYear = new Date().getFullYear()
      this.startYear = currentYear - 3 // 大前年
      this.endYear = currentYear // 今年
      this.$emit('yearChange', [this.startYear, this.endYear])
    },
    handleStartYearChange(value) {
      if (value > this.endYear) {
        this.$message.warning('起始年份不能大于结束年份')
        this.startYear = this.endYear
        return
      }
      this.$emit('yearChange', [this.startYear, this.endYear])
    },
    handleEndYearChange(value) {
      if (value < this.startYear) {
        this.$message.warning('结束年份不能小于起始年份')
        this.endYear = this.startYear
        return
      }
      this.$emit('yearChange', [this.startYear, this.endYear])
    }
  },
  watch: {
    value: {
      handler(newVal) {
        if (newVal && newVal.length === 2) {
          this.startYear = newVal[0]
          this.endYear = newVal[1]
        }
      },
      immediate: true
    }
  }
}
</script>

<style scoped>
.year-range-picker {
  display: inline-flex;
  align-items: center;
}
.separator {
  margin: 0 8px;
  color: #606266;
}
</style>
